"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AminoTypes = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const encoding_1 = require("@cosmjs/encoding");
const launchpad_1 = require("@cosmjs/launchpad");
const utils_1 = require("@cosmjs/utils");
const stargateclient_1 = require("./stargateclient");
function createDefaultTypes(prefix) {
    return {
        "/cosmos.bank.v1beta1.MsgSend": {
            aminoType: "cosmos-sdk/MsgSend",
            toAmino: ({ fromAddress, toAddress, amount }) => {
                utils_1.assertDefinedAndNotNull(fromAddress, "missing fromAddress");
                utils_1.assertDefinedAndNotNull(toAddress, "missing toAddress");
                utils_1.assertDefinedAndNotNull(amount, "missing amount");
                return {
                    from_address: fromAddress,
                    to_address: toAddress,
                    amount: amount.map(stargateclient_1.coinFromProto),
                };
            },
            fromAmino: ({ from_address, to_address, amount }) => ({
                fromAddress: from_address,
                toAddress: to_address,
                amount: [...amount],
            }),
        },
        "/cosmos.bank.v1beta1.MsgMultiSend": {
            aminoType: "cosmos-sdk/MsgMultiSend",
            toAmino: ({ inputs, outputs }) => {
                utils_1.assertDefinedAndNotNull(inputs, "missing inputs");
                utils_1.assertDefinedAndNotNull(outputs, "missing outputs");
                return {
                    inputs: inputs.map((input) => {
                        utils_1.assertDefinedAndNotNull(input.address, "missing input.address");
                        utils_1.assertDefinedAndNotNull(input.coins, "missing input.amount");
                        return {
                            address: input.address,
                            coins: input.coins.map(stargateclient_1.coinFromProto),
                        };
                    }),
                    outputs: outputs.map((output) => {
                        utils_1.assertDefinedAndNotNull(output.address, "missing output.address");
                        utils_1.assertDefinedAndNotNull(output.coins, "missing output.coins");
                        return {
                            address: output.address,
                            coins: output.coins.map(stargateclient_1.coinFromProto),
                        };
                    }),
                };
            },
            fromAmino: ({ inputs, outputs }) => ({
                inputs: inputs.map((input) => ({
                    address: input.address,
                    coins: [...input.coins],
                })),
                outputs: outputs.map((output) => ({
                    address: output.address,
                    coins: [...output.coins],
                })),
            }),
        },
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
            aminoType: "cosmos-sdk/MsgFundCommunityPool",
            toAmino: ({ amount, depositor }) => {
                utils_1.assertDefinedAndNotNull(amount);
                utils_1.assertDefinedAndNotNull(depositor);
                return {
                    amount: amount.map(stargateclient_1.coinFromProto),
                    depositor: depositor,
                };
            },
            fromAmino: ({ amount, depositor }) => ({
                amount: [...amount],
                depositor: depositor,
            }),
        },
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
            aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
            toAmino: ({ delegatorAddress, withdrawAddress, }) => {
                utils_1.assertDefinedAndNotNull(delegatorAddress);
                utils_1.assertDefinedAndNotNull(withdrawAddress);
                return {
                    delegator_address: delegatorAddress,
                    withdraw_address: withdrawAddress,
                };
            },
            fromAmino: ({ delegator_address, withdraw_address, }) => ({
                delegatorAddress: delegator_address,
                withdrawAddress: withdraw_address,
            }),
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
            aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
            toAmino: ({ delegatorAddress, validatorAddress, }) => {
                utils_1.assertDefinedAndNotNull(delegatorAddress);
                utils_1.assertDefinedAndNotNull(validatorAddress);
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                };
            },
            fromAmino: ({ delegator_address, validator_address, }) => ({
                delegatorAddress: delegator_address,
                validatorAddress: validator_address,
            }),
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
            aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
            toAmino: ({ validatorAddress, }) => {
                utils_1.assertDefinedAndNotNull(validatorAddress);
                return {
                    validator_address: validatorAddress,
                };
            },
            fromAmino: ({ validator_address, }) => ({
                validatorAddress: validator_address,
            }),
        },
        "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
            aminoType: "cosmos-sdk/MsgBeginRedelegate",
            toAmino: ({ delegatorAddress, validatorSrcAddress, validatorDstAddress, amount, }) => {
                utils_1.assertDefinedAndNotNull(delegatorAddress, "missing delegatorAddress");
                utils_1.assertDefinedAndNotNull(validatorSrcAddress, "missing validatorSrcAddress");
                utils_1.assertDefinedAndNotNull(validatorDstAddress, "missing validatorDstAddress");
                utils_1.assertDefinedAndNotNull(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_src_address: validatorSrcAddress,
                    validator_dst_address: validatorDstAddress,
                    amount: stargateclient_1.coinFromProto(amount),
                };
            },
            fromAmino: ({ delegator_address, validator_src_address, validator_dst_address, amount, }) => ({
                delegatorAddress: delegator_address,
                validatorSrcAddress: validator_src_address,
                validatorDstAddress: validator_dst_address,
                amount: amount,
            }),
        },
        "/cosmos.staking.v1beta1.MsgCreateValidator": {
            aminoType: "cosmos-sdk/MsgCreateValidator",
            toAmino: ({ description, commission, minSelfDelegation, delegatorAddress, validatorAddress, pubkey, value, }) => {
                utils_1.assertDefinedAndNotNull(description, "missing description");
                utils_1.assertDefinedAndNotNull(description.moniker, "missing description.moniker");
                utils_1.assertDefinedAndNotNull(description.identity, "missing description.identity");
                utils_1.assertDefinedAndNotNull(description.website, "missing description.website");
                utils_1.assertDefinedAndNotNull(description.securityContact, "missing description.securityContact");
                utils_1.assertDefinedAndNotNull(description.details, "missing description.details");
                utils_1.assertDefinedAndNotNull(commission, "missing commission");
                utils_1.assertDefinedAndNotNull(commission.rate, "missing commission.rate");
                utils_1.assertDefinedAndNotNull(commission.maxRate, "missing commission.maxRate");
                utils_1.assertDefinedAndNotNull(commission.maxChangeRate, "missing commission.maxChangeRate");
                utils_1.assertDefinedAndNotNull(minSelfDelegation, "missing minSelfDelegation");
                utils_1.assertDefinedAndNotNull(delegatorAddress, "missing delegatorAddress");
                utils_1.assertDefinedAndNotNull(validatorAddress, "missing validatorAddress");
                utils_1.assertDefinedAndNotNull(pubkey, "missing pubkey");
                utils_1.assertDefinedAndNotNull(pubkey.value, "missing pubkey.value");
                utils_1.assertDefinedAndNotNull(value, "missing value");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details,
                    },
                    commission: {
                        rate: commission.rate,
                        max_rate: commission.maxRate,
                        max_change_rate: commission.maxChangeRate,
                    },
                    min_self_delegation: minSelfDelegation,
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    pubkey: launchpad_1.encodeBech32Pubkey({
                        type: "tendermint/PubKeySecp256k1",
                        value: encoding_1.toBase64(pubkey.value),
                    }, prefix),
                    value: stargateclient_1.coinFromProto(value),
                };
            },
            fromAmino: ({ description, commission, min_self_delegation, delegator_address, validator_address, pubkey, value, }) => {
                const decodedPubkey = launchpad_1.decodeBech32Pubkey(pubkey);
                if (decodedPubkey.type !== "tendermint/PubKeySecp256k1") {
                    throw new Error("Only Secp256k1 public keys are supported");
                }
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details,
                    },
                    commission: {
                        rate: commission.rate,
                        maxRate: commission.max_rate,
                        maxChangeRate: commission.max_change_rate,
                    },
                    minSelfDelegation: min_self_delegation,
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    pubkey: {
                        typeUrl: "/cosmos.crypto.secp256k1.PubKey",
                        value: encoding_1.fromBase64(decodedPubkey.value),
                    },
                    value: value,
                };
            },
        },
        "/cosmos.staking.v1beta1.MsgDelegate": {
            aminoType: "cosmos-sdk/MsgDelegate",
            toAmino: ({ delegatorAddress, validatorAddress, amount, }) => {
                utils_1.assertDefinedAndNotNull(delegatorAddress, "missing delegatorAddress");
                utils_1.assertDefinedAndNotNull(validatorAddress, "missing validatorAddress");
                utils_1.assertDefinedAndNotNull(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: stargateclient_1.coinFromProto(amount),
                };
            },
            fromAmino: ({ delegator_address, validator_address, amount, }) => ({
                delegatorAddress: delegator_address,
                validatorAddress: validator_address,
                amount: amount,
            }),
        },
        "/cosmos.staking.v1beta1.MsgEditValidator": {
            aminoType: "cosmos-sdk/MsgEditValidator",
            toAmino: ({ description, commissionRate, minSelfDelegation, validatorAddress, }) => {
                utils_1.assertDefinedAndNotNull(description, "missing description");
                utils_1.assertDefinedAndNotNull(description.moniker, "missing description.moniker");
                utils_1.assertDefinedAndNotNull(description.identity, "missing description.identity");
                utils_1.assertDefinedAndNotNull(description.website, "missing description.website");
                utils_1.assertDefinedAndNotNull(description.securityContact, "missing description.securityContact");
                utils_1.assertDefinedAndNotNull(description.details, "missing description.details");
                utils_1.assertDefinedAndNotNull(commissionRate, "missing commissionRate");
                utils_1.assertDefinedAndNotNull(minSelfDelegation, "missing minSelfDelegation");
                utils_1.assertDefinedAndNotNull(validatorAddress, "missing validatorAddress");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details,
                    },
                    commission_rate: commissionRate,
                    min_self_delegation: minSelfDelegation,
                    validator_address: validatorAddress,
                };
            },
            fromAmino: ({ description, commission_rate, min_self_delegation, validator_address, }) => ({
                description: {
                    moniker: description.moniker,
                    identity: description.identity,
                    website: description.website,
                    securityContact: description.security_contact,
                    details: description.details,
                },
                commissionRate: commission_rate,
                minSelfDelegation: min_self_delegation,
                validatorAddress: validator_address,
            }),
        },
        "/cosmos.staking.v1beta1.MsgUndelegate": {
            aminoType: "cosmos-sdk/MsgUndelegate",
            toAmino: ({ delegatorAddress, validatorAddress, amount, }) => {
                utils_1.assertDefinedAndNotNull(delegatorAddress, "missing delegatorAddress");
                utils_1.assertDefinedAndNotNull(validatorAddress, "missing validatorAddress");
                utils_1.assertDefinedAndNotNull(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: stargateclient_1.coinFromProto(amount),
                };
            },
            fromAmino: ({ delegator_address, validator_address, amount, }) => ({
                delegatorAddress: delegator_address,
                validatorAddress: validator_address,
                amount: amount,
            }),
        },
    };
}
/**
 * A map from Stargate message types as used in the messages's `Any` type
 * to Amino types.
 */
class AminoTypes {
    constructor({ additions = {}, prefix = "cosmos" } = {}) {
        const additionalAminoTypes = Object.values(additions);
        const filteredDefaultTypes = Object.entries(createDefaultTypes(prefix)).reduce((acc, [key, value]) => additionalAminoTypes.find(({ aminoType }) => value.aminoType === aminoType)
            ? acc
            : Object.assign(Object.assign({}, acc), { [key]: value }), {});
        this.register = Object.assign(Object.assign({}, filteredDefaultTypes), additions);
    }
    toAmino({ typeUrl, value }) {
        const converter = this.register[typeUrl];
        if (!converter) {
            throw new Error("Type URL does not exist in the Amino message type register. " +
                "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " +
                "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
        }
        return {
            type: converter.aminoType,
            value: converter.toAmino(value),
        };
    }
    fromAmino({ type, value }) {
        const result = Object.entries(this.register).find(([_typeUrl, { aminoType }]) => aminoType === type);
        if (!result) {
            throw new Error("Type does not exist in the Amino message type register. " +
                "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " +
                "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
        }
        const [typeUrl, converter] = result;
        return {
            typeUrl: typeUrl,
            value: converter.fromAmino(value),
        };
    }
}
exports.AminoTypes = AminoTypes;
//# sourceMappingURL=aminotypes.js.map